
import Input from "../Input";
import Output from "../Output";


import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import kinai from "../../assets/kinai.jpg"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarKinai({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar kínai fordító</title>
                <meta name='description' content="Ingyenes magyar kínai fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar kínai fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-kinai-fordito" />
            </Helmet>
            <h1>Magyar kínai fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és kínai nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={kinai} alt="kínai zászló"></img>
                </div>


                <p>A kínai és a magyar nyelv két különböző nyelv, amelyek teljesen különböző nyelvcsaládokba tartoznak. A kínai egy szinotibeti nyelvcsaládba tartozik, míg a magyar ugor-altaikus nyelvcsaládba.</p>

                <h3>Különbségek</h3>


                <ul>
                    <li><b>Nyelvcsalád és rokonság</b>: A kínai és a magyar nyelv nyelvcsaládjukban és struktúrájukban is eltérőek. A kínai egyedülálló nyelvcsaládba tartozik, míg a magyar ugor-altaikus nyelvcsaládba. Ez azt jelenti, hogy a két nyelv nyelvtani és szókincsbeli jellemzői nagyon eltérőek.</li>

                    <li><b>Hangzások és kiejtés</b>: A kínai nyelvben a szavak hangzása és kiejtése nagyon eltérő a magyartól. A kínai nyelvben például nagy hangsúlyt kapnak a hangsúlyos tónusok, amelyek a szavak jelentését is megváltoztathatják, míg a magyar nyelvben nincsenek tónusok.</li>

                    <li><b>Írásrendszer</b>: A kínai nyelv hieroglifákból álló írásrendszerrel rendelkezik, míg a magyar nyelv latin betűs írásrendszert használ. A kínai írásrendszer komplexebb és több karaktert tartalmaz.</li>

                    <li><b>Nyelvtani struktúra</b>: A kínai és a magyar nyelv nyelvtani struktúrája jelentősen eltér. A kínai nyelvben nincs ragozás és kevés grammatikai szerkezet, míg a magyar nyelv gazdag ragozású és bonyolultabb nyelvtani szabályokkal rendelkezik.</li>
                </ul>


                <h3>Hasonlóságok</h3>


                <ul>
                    <li><b>Szórend</b>: Mind a kínai, mind a magyar nyelvben a szórend fontos szerepet játszik a mondatok értelmének kifejezésében. Mindkét nyelvben a szubjektum, az ige és az objektum szórendje jellemző.</li>

                    <li><b>Szókincs</b>: Bár a kínai és a magyar nyelvnek eltérő szókincse van, néhány közös szó vagy kifejezés is található közöttük, amelyek az idők során átvándoroltak a két nyelv között, vagy közös történelmi, kulturális kapcsolatokra utalnak.</li>

                    <li><b>Kulturális elemek</b>: A kínai és a magyar nyelvben lehetnek olyan kifejezések vagy szófordulatok, amelyek kulturális vagy történelmi hátterük miatt hasonlóságot mutatnak. Ez kapcsolódhat a két nyelv közötti kulturális kölcsönhatásokhoz vagy az átvett kifejezésekhez.</li>

                </ul>


                <div className="sectionbottom">
                    <Link to="/kinai-magyar-fordito">Kínai magyar fordító</Link>
                    <img src={kinai} alt="kínai zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarKinai;